module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Gauge.js"));
	}, "Gauge");
}